<template>
  <v-card class="pa-4" flat>
    <v-row class="mb-4 d-flex align-center" no-gutters>
      <v-col class="d-flex justify-end">
        <v-btn @click="openAddModal" class="rounded-lg btn-get-code" depressed>
          افزودن تعرفه جدید
          <v-icon left>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-progress-linear v-show="loading" class="mb-2" indeterminate />

    <!-- جدول تعرفه‌ها -->
    <vue-table
      :data="packs"
      :headers="headers"
      :loading.sync="loading"
      @change="onPagination"
    >
      <template v-slot:index="{ item, index }">
        {{ item.index + 1 }}
      </template>

      <template v-slot:type="{ item }">
        <v-chip :color="item.type === 'pro' ? 'success' : 'primary'" small dark>
          {{ item.type === "pro" ? "پولی" : "رایگان" }}
        </v-chip>
      </template>

      <template v-slot:price="{ item }">
        <span v-if="item.type === 'free'">رایگان</span>
        <span v-else
          >{{ persian(Number(item.price).toLocaleString()) }} تومان</span
        >
      </template>

      <template v-slot:discount="{ item }">
        {{ item.discount ? item.discount + " %" : "ندارد" }}
      </template>

      <template v-slot:time="{ item }">
        {{ item.time ? persian(item.time) : "نامشخص" }} روز
      </template>

      <template v-slot:action="{ item }">
        <manage-button :data="item" :meta="metaButtons" />
      </template>
    </vue-table>

    <!-- مدال افزودن / ویرایش تعرفه -->
    <custom-popup
      v-model="showForm"
      max-width="600"
      persistent
      :cons="{ title: isEdit ? 'ویرایش تعرفه' : 'افزودن تعرفه جدید' }"
    >
      <v-card class="rounded-xl">
        <v-card-text class="pa-5">
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.title"
                  label="عنوان تعرفه"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'عنوان الزامی است']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="form.time"
                  label="مدت زمان (روز)"
                  type="number"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'زمان الزامی است',
                    (v) => v >= 1 || 'حداقل ۱ روز',
                  ]"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="form.type"
                  :items="[
                    { text: 'رایگان', value: 'free' },
                    { text: 'پولی', value: 'pro' },
                  ]"
                  label="نوع تعرفه"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'نوع تعرفه الزامی است']"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.product_id"
                  label="شناسه محصول"
                  outlined
                  dense
                  :rules="[(v) => (!!v && !isEdit) || 'شناسه محصول الزامی است']"
                  class="direction-ltr"
                />
              </v-col>

              <v-col cols="12" md="6" v-if="form.type === 'pro'">
                <v-text-field
                  v-model.number="form.price"
                  label="قیمت (تومان)"
                  type="number"
                  outlined
                  dense
                  :rules="[
                    (v) => form.type !== 'pro' || !!v || 'قیمت الزامی است',
                    (v) =>
                      form.type !== 'pro' ||
                      v >= 1 ||
                      'قیمت باید بیشتر از صفر باشد',
                  ]"
                />
              </v-col>

              <v-col cols="12" md="6" v-if="form.type === 'pro'">
                <v-text-field
                  v-model.number="form.discount"
                  label="تخفیف (درصد)"
                  type="number"
                  outlined
                  dense
                  :rules="[
                    (v) =>
                      !v ||
                      (v >= 0 && v <= 100) ||
                      'تخفیف باید بین 0 تا 100 باشد',
                  ]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="d-flex justify-space-between">
          <v-btn class="rounded-lg btn-delete" @click="closeModal"
            ><v-icon>mdi-close</v-icon>انصراف</v-btn
          >
          <v-btn
            class="rounded-lg btn-get-code"
            depressed
            :loading="btnLoading"
            :disabled="!valid"
            @click="savePack"
          >
            {{ isEdit ? "ذخیره تغییرات" : "ثبت تعرفه" }}
            <v-icon>{{ isEdit ? "mdi-plus" : "mdi-edit" }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import ManageButton from "./manageButton.vue";

export default {
  name: "managementPack",
  components: {
    ManageButton,
  },
  data() {
    return {
      packs: {
        per_page: 100,
        current_page: 1,
        data: [],
        total: 1000,
        to: 1,
      },
      loading: false,
      btnLoading: false,
      showForm: false,
      valid: false,
      isEdit: false,
      editId: null,

      tableProps: {
        page: 1,
        length: 10,
      },

      form: {
        title: "",
        time: null,
        type: "pro",
        discount: null,
        price: null,
        product_id: "",
      },

      defaultForm: {
        title: "",
        time: null,
        type: "pro",
        discount: null,
        price: null,
        product_id: "",
      },

      metaButtons: {
        buttons: [
          {
            name: "edit",
            label: "ویرایش",
            icon: "pencil",
            class: "btn-edit border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-can",
            class: "btn-refund border-2 rounded-pill",
            action: this.action,
          },
        ],
      },
    };
  },
  computed: {
    headers() {
      return [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        {
          value: "title",
          text: "عنوان تعرفه",
          align: "center",
          sortable: false,
        },
        { value: "type", text: "نوع", align: "center", sortable: false },
        { value: "price", text: "قیمت", align: "center", sortable: false },
        { value: "discount", text: "تخفیف", align: "center", sortable: false },
        { value: "time", text: "مدت زمان", align: "center", sortable: false },
        {
          value: "product_id",
          text: "شناسه محصول",
          align: "center",
          sortable: false,
        },
        { value: "action", text: "عملیات", align: "center", sortable: false },
      ];
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch(props = this.tableProps) {
      this.loading = true;
      this.$api
        .get(`${this.$aiApi}/admin/assistant/pack`, { params: props })
        .then((response) => {
          const rawData = response.data;
          const formattedArray = Object.keys(rawData)
            .filter((key) => key !== "message")
            .map((key) => rawData[key]);

          this.packs.data = formattedArray;
        })
        .catch((err) => {
          this.$toast.error("خطا در دریافت لیست تعرفه‌ها");
        })
        .finally(() => (this.loading = false));
    },

    onPagination(e) {
      this.tableProps = { ...this.tableProps, ...e };
      this.fetch();
    },

    action(data, actionName) {
      this[`${actionName}Action`](data);
    },

    openAddModal() {
      this.isEdit = false;
      this.editId = null;
      this.form = { ...this.defaultForm };
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.showForm = true;
    },

    editAction(item) {
      this.isEdit = true;
      this.editId = item.id;
      // پر کردن فرم با دیتای موجود
      this.form = {
        title: item.title,
        time: Number(item.time),
        type: item.type,
        discount: item.discount ? Number(item.discount) : null,
        price: item.price ? Number(item.price) : null,
        product_id: item.product_id,
      };
      this.showForm = true;
    },

    async deleteAction(item) {
      if (await this.$modal.yesNo("آیا از حذف این تعرفه اطمینان دارید؟")) {
        this.loading = true;
        this.$api
          .delete(`${this.$aiApi}/admin/assistant/pack/${item.id}`)
          .then(() => {
            this.$toast.success("تعرفه با موفقیت حذف شد");
            this.fetch();
          })
          .catch((err) => {
            this.$toast.error("خطا در حذف تعرفه");
          })
          .finally(() => (this.loading = false));
      }
    },

    savePack() {
      if (!this.$refs.form.validate()) return;

      this.btnLoading = true;

      const payload = { ...this.form };
      if (payload.type === "free") {
        payload.price = null;
        payload.discount = null;
      }
      if (payload?.discount?.trim() === "") {
        payload.discount = null;
      }

      const method = this.isEdit ? "put" : "post";
      const url = this.isEdit
        ? `${this.$aiApi}/admin/assistant/pack/${this.editId}`
        : `${this.$aiApi}/admin/assistant/pack`;

      this.$api[method](url, payload)
        .then(() => {
          this.$toast.success(
            this.isEdit ? "تعرفه با ویرایش شد" : "تعرفه با موفقیت ایجاد شد",
          );
          this.closeModal();
          this.fetch();
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "خطا در ذخیره تعرفه";
          this.$toast.error(msg);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    closeModal() {
      this.showForm = false;
      this.form = { ...this.defaultForm };
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
.border-b {
  border-bottom: 1px solid #f1f5f9 !important;
}
.direction-ltr {
  direction: ltr !important;
  text-align: left !important;
}
</style>
